/** Sent generated receipts that must stay downloadable after reload (CTL-Send 3.23). */
export function isSentCtlReceipt(row: { direction: string; kind: string }): boolean {
  return row.direction === 'out' &&
    (row.kind === 'XCTL02' || row.kind === 'XCTL03' || row.kind === 'CTL02' || row.kind === 'CTL03');
}

export function ctlReceiptDownloadFilename(
  kind: string,
  envelopeIdentifier: string | null | undefined,
  id: string,
): string {
  const safeKind = kind.replace(/[^A-Za-z0-9]/g, '') || 'XCTL';
  const envelope = envelopeIdentifier?.replace(/[^A-Za-z0-9._-]/g, '') ?? '';
  const ext = kind === 'CTL02' || kind === 'CTL03' ? 'edi' : 'xml';
  return envelope ? `${safeKind}_${envelope}.${ext}` : `${safeKind}_${id.slice(0, 8)}.${ext}`;
}

function decodeXmlText(value: string): string {
  return value
    .replace(/&#(\d+);/g, (_, digits: string) => String.fromCodePoint(Number(digits)))
    .replace(/&#x([0-9a-fA-F]+);/g, (_, hex: string) => String.fromCodePoint(parseInt(hex, 16)))
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&amp;/g, '&');
}

function textsFromTag(xml: string, tag: string): string[] {
  const texts: string[] = [];
  const re = new RegExp(`<${tag}(?:\\s[^>]*)?>([\\s\\S]*?)</${tag}>`, 'gi');
  let match: RegExpExecArray | null;
  while ((match = re.exec(xml)) !== null) {
    const text = decodeXmlText(match[1] ?? '').trim();
    if (text) texts.push(text);
  }
  return texts;
}

/** Refuse / error text from a stored XCONTRL payload. Does not change the XML. */
export function ctlRefuseTextsFromXml(xml: string): string[] {
  return textsFromTag(xml, 'RefuseText');
}

export function ctlRefuseCodeFromXml(xml: string): string | null {
  return textsFromTag(xml, 'RefuseCode')[0] ?? null;
}
